import { render, staticRenderFns } from "./ContractIndex.vue?vue&type=template&id=9b5bbd96&"
import script from "./ContractIndex.vue?vue&type=script&lang=js&"
export * from "./ContractIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports